const CardChipButton = ({ isDisabled, isStatus, title, data }) => {
  return (
    <div className="flex flex-col justify-start items-start gap-2 ">
      <div className="justify-start text-global-title-3 text-sm font-semibold  leading-tight">
        {title}
      </div>

      <div
        className={
          "px-1.5 py-[1px]  gap-1 flex justify-center items-center custom-card-buttom rounded-md border border-[#D0D5DD] bg-white shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]"
        }
      >
        {isStatus && <div className="bg-global-primary w-1.5 h-1.5 rounded-full" />}
        {isDisabled && <div className="bg-[#808080] w-1.5 h-1.5 rounded-full" />}
        <div className="text-[#344054] text-xs leading-[18px] font-medium capitalize">{data}</div>
      </div>
    </div>
  );
};

export default CardChipButton;
